import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'mb-view-components-dialog',
  templateUrl: './view-components-dialog.component.html',
})
export class ViewComponentsDialogComponent {

  @Input() components: any

  constructor (public activeModal: NgbActiveModal) {
  }
}
